import { clientFunction } from '../../config/apollo/client';
import { observer } from 'mobx-react';

import * as SplashScreen from 'expo-splash-screen';
import * as storage from '../../utils/storage';
import FlashMessage from 'react-native-flash-message';
import React, { FC, PropsWithChildren, useEffect } from 'react';
import useCachedResources from '../../hooks/useCachedResources';
import { AndroidSystemBarInset } from './AndroidSystemBarInset';
import { ApolloProvider } from '@apollo/client';
import { JailBreakProtectedApp } from './JailBreakProtectedApp';
import { RedirectApp } from './RedirectApp';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { StatusBar } from 'expo-status-bar';
import { UpdateApp } from './UpdateApp';
import { addTrigger } from '../../utils/onesignal/addTrigger';
import { logAmplitude } from '../../utils/analytics/analytics';
import { removeIAMClickHandler, setIAMClickHandler } from '../../utils/onesignal/setIAMClickHandler';
import { useOneSignal } from './OneSignalContext';
import { useStores } from '../../hooks/useStores';




export const ApolloApp: FC<PropsWithChildren> = observer(({children}) => {
  const rootStore = useStores();
  const storeIsReady = rootStore?.language?.ready;
  const isLoadingComplete = useCachedResources();

  const [displayMainPart, setDisplayMainPart] = React.useState(false);

  const lang = rootStore?.language.name.key;

  const { isInitialized } = useOneSignal();

  React.useEffect(()=> {
    if(isLoadingComplete && storeIsReady) {
      setDisplayMainPart(true);

    }
  },[isLoadingComplete, storeIsReady]);



  React.useEffect(() => {
    SplashScreen.hideAsync();

    logAmplitude('App Launched');

  }, []);





  useEffect(() => {
    if(isInitialized) {
      addTrigger('app_launched', String(rootStore?.onboarding?.onboardingShow));
      const listener = setIAMClickHandler(value => {
        if (value === 'end_of_onboarding') {
          storage.saveString('doneOnboarding', 'true');
          rootStore?.onboarding.set(false);
        }

        if (value === 'leave_before_onboarding_survey') {
          storage.saveString('doneOnboarding', 'true');
          rootStore?.onboarding.set(false);
          addTrigger('send_me_push_notification_prompt_please', lang);
        }
      });
      return () => {
        removeIAMClickHandler(listener);
      };
    }
  },[isInitialized]);






  const client = clientFunction(lang);
  if(displayMainPart) {
    return (

      <ApolloProvider client={client}>
        <SafeAreaProvider>
          <AndroidSystemBarInset>
            <JailBreakProtectedApp>
              <RedirectApp>
                <UpdateApp>
                  {children}
                </UpdateApp>
              </RedirectApp>
            </JailBreakProtectedApp>
          </AndroidSystemBarInset>
          <StatusBar />
        </SafeAreaProvider>
        <FlashMessage position='top' />
      </ApolloProvider>
    );
  }

});
